export default __webpack_public_path__ + "static/media/thunderingflames.cf8a0372.png";